<script>
    import { createEventDispatcher, onMount } from 'svelte';

    export let tabs;
    export let id;
    export let selected_index = 0;

    const dispatcher = createEventDispatcher();

    function select(index) {
        selected_index = index;
        dispatcher('change', { tab: tabs[index], index });
    }

    function scrollToTab(target) {
        target.scrollIntoView({ behavior: 'smooth' });
    }
</script>

{#if tabs}
    <!-- m-product-detail__desc -->
    <section class="u-tabs" {id}>
        <header class="u-tabs__header">
            {#each tabs as tab, index}
                {#if index == selected_index}
                    <span class="u-tabs__nav active">{tab.title}</span>
                {:else}
                    <button
                        class="u-tabs__nav"
                        on:click={(event) => {
                            select(index);
                            scrollToTab(event.target);
                        }}>{tab.title}</button
                    >
                {/if}
            {/each}
        </header>
        <div class="u-tabs__content">
            <slot />
        </div>
        <slot name="content" />
    </section>
{/if}
